export default "__VITE_ASSET__uWz1bJmP__"